import React from 'react';

export const ConvincerSVG = () => (
    <svg
        width="261"
        height="134"
        viewBox="0 0 261 134"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M261 121.889L248.974 117.511L244.597 129.539L256.623 133.917L261 121.889Z"
            fill="#982EA9"
        />
        <rect
            width="12.7976"
            height="12.7999"
            transform="matrix(-0.939674 -0.342072 -0.341976 0.939709 157.833 4.37793)"
            fill="#982EA9"
        />
        <path
            d="M194.623 110.679L185.847 115.954L191.12 124.731L199.896 119.457L194.623 110.679Z"
            fill="#E3C5E7"
        />
        <path
            d="M11.2539 111.413L1.07053 110.343L-0.000371369 120.527L10.183 121.597L11.2539 111.413Z"
            fill="#B394F2"
        />
        <rect
            width="6.40143"
            height="6.40208"
            transform="matrix(-0.990265 -0.139198 -0.139149 0.990272 81.0381 7.72266)"
            fill="#BD79C8"
        />
        <rect
            width="6.40143"
            height="6.40208"
            transform="matrix(-0.566367 -0.824154 -0.8241 0.566446 231.637 29.8706)"
            fill="#BD79C8"
        />
        <rect
            opacity="0.8"
            width="10.2395"
            height="10.2399"
            transform="matrix(-0.828994 -0.559257 -0.559129 0.829081 107.15 38.5195)"
            fill="#B394F2"
        />
        <rect
            width="7.67938"
            height="7.68013"
            transform="matrix(-0.97814 -0.207952 -0.207872 0.978157 185.766 31.2876)"
            fill="#B394F2"
        />
        <rect
            width="7.67938"
            height="7.68013"
            transform="matrix(-0.97814 -0.207952 -0.207872 0.978157 89.7471 120.474)"
            fill="#982EA9"
        />
        <path
            d="M259.627 90.1833C257.016 86.2587 248.96 79.8153 237.631 85.4383"
            stroke="#BD79C8"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M33.4791 97.4207C36.2701 102.631 44.3041 111.527 54.1118 105.431"
            stroke="#982EA9"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.6656 56.2288C36.4491 55.8524 35.2055 55.1495 33.8217 53.435C33.5533 53.4443 32.9826 54.5987 33.0808 55.7377L33.0824 55.7572C33.1957 57.0786 33.4086 59.5628 37.3172 61.2483C36.527 61.387 35.425 61.3687 34.3654 60.9483C34.4294 62.774 36.1137 66.1426 41.2801 66.3054C41.0152 67.0002 39.6864 67.1609 38.8778 67.2462C39.7496 68.9299 41.9879 69.9371 44.5389 69.9055C44.8019 69.9021 45.1571 69.8619 45.5638 69.8158C46.4689 69.7131 47.6288 69.5817 48.5929 69.7643C50.1738 70.0636 50.7929 70.301 51.9114 71.5844C51.9075 71.4721 51.9422 71.2356 51.9912 70.9012C52.2884 68.8751 53.1124 63.2568 49.0601 59.9227C48.9834 59.8595 48.9084 59.7973 48.8345 59.7359C47.2403 58.4132 46.1367 57.4976 38.6656 56.2288ZM39.915 58.047C38.3264 57.7772 36.0905 57.389 34.7197 56.4172C35.0561 57.6084 35.35 58.0131 36.0283 58.6455C36.904 59.4703 40.1157 60.786 42.0588 61.582C42.3297 61.693 42.5759 61.7938 42.7877 61.8819L42.7503 61.8884C42.0473 62.0119 37.6891 62.7771 36.7852 62.9032C37.7735 64.1231 39.5557 64.8715 43.4999 64.8113C43.4503 64.9289 43.3917 65.1167 43.3207 65.3443C43.0727 66.1394 42.6729 67.4208 41.9758 67.8992C42.0762 67.9677 42.6656 68.2656 44.3757 68.3314C44.6587 68.3278 45.0052 68.289 45.3987 68.2449C45.8505 68.1943 46.3643 68.1367 46.9154 68.1175C47.9466 68.0816 49.3569 68.129 50.6599 68.6915C50.6604 68.6853 50.6609 68.6784 50.6614 68.6709C50.7052 68.0749 51.046 63.4391 47.9203 60.9908C47.8399 60.9278 47.7623 60.8666 47.6868 60.8071C46.1783 59.6176 45.5012 59.0837 39.915 58.047Z"
            fill="#BD79C8"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.7194 56.4167C36.0902 57.3885 38.3261 57.7767 39.9147 58.0465C45.7806 59.1351 46.2335 59.6692 47.92 60.9903C51.0849 63.4692 50.6958 68.191 50.6596 68.6909C49.3566 68.1284 47.9463 68.0811 46.9151 68.117C45.884 68.1529 44.9834 68.3232 44.3754 68.3309C42.6653 68.265 42.0759 67.9672 41.9756 67.8986C42.8721 67.2833 43.2769 65.3395 43.4996 64.8107C39.5554 64.8709 37.7732 64.1225 36.7849 62.9026C37.7067 62.774 42.221 61.9808 42.7874 61.8813C41.0562 61.1618 37.0257 59.5848 36.028 58.645C35.3497 58.0125 35.0558 57.6079 34.7194 56.4167Z"
            fill="#BD79C8"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M220.813 59.4484C223.34 59.3323 224.825 58.7181 226.605 56.9934C226.904 57.0407 227.383 58.4081 227.117 59.6666L227.113 59.6881C226.805 61.1482 226.227 63.8931 221.631 65.2387C222.495 65.5021 223.728 65.6329 224.969 65.3089C224.647 67.3389 222.305 70.8693 216.513 70.342C216.713 71.1542 218.175 71.5161 219.067 71.7224C217.863 73.4829 215.225 74.3003 212.38 73.9149C212.087 73.8751 211.696 73.7813 211.248 73.674C210.251 73.4352 208.974 73.1291 207.872 73.2007C206.065 73.3181 205.342 73.4981 203.917 74.7778C203.936 74.6529 203.93 74.384 203.921 74.0039C203.867 71.7006 203.716 65.3135 208.698 62.1465C208.793 62.0865 208.885 62.0273 208.976 61.969C210.937 60.7108 212.295 59.8398 220.813 59.4484ZM219.168 61.307C220.979 61.2238 223.53 61.0972 225.194 60.2001C224.655 61.4842 224.271 61.8957 223.427 62.5089C222.336 63.3097 218.569 64.3381 216.29 64.9603C215.972 65.047 215.683 65.1258 215.435 65.195L215.476 65.2077C216.246 65.4424 221.006 66.8946 221.998 67.1594C220.728 68.386 218.635 68.9771 214.238 68.3685C214.277 68.5067 214.317 68.7245 214.365 68.9884C214.533 69.9103 214.804 71.3961 215.517 72.026C215.396 72.0887 214.697 72.3405 212.778 72.1793C212.462 72.1364 212.081 72.0455 211.647 71.9423C211.149 71.8237 210.584 71.6889 209.971 71.5918C208.824 71.4102 207.242 71.2695 205.71 71.7187C205.711 71.7117 205.711 71.704 205.711 71.6956C205.744 71.024 205.999 65.8004 209.825 63.4955C209.923 63.4362 210.018 63.3785 210.111 63.3224C211.958 62.2012 212.788 61.6979 219.168 61.307Z"
            fill="#B394F2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M225.194 60.2C223.53 61.0971 220.979 61.2236 219.168 61.3068C212.468 61.7173 211.889 62.2517 209.825 63.4954C205.951 65.8292 205.738 71.1553 205.71 71.7186C207.243 71.2693 208.824 71.41 209.971 71.5917C211.117 71.7733 212.1 72.0871 212.778 72.1791C214.697 72.3403 215.396 72.0886 215.517 72.0258C214.6 71.2157 214.414 68.9894 214.238 68.3684C218.635 68.977 220.728 68.3859 221.999 67.1593C220.987 66.8892 216.054 65.3837 215.435 65.1949C217.467 64.6291 222.184 63.4212 223.427 62.5087C224.271 61.8955 224.655 61.484 225.194 60.2Z"
            fill="#B394F2"
        />
        <ellipse
            cx="131.866"
            cy="88.8172"
            rx="32.7958"
            ry="32.7938"
            fill="#982EA9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M148.314 70.7832C145.771 74.1687 143.43 75.6017 139.198 76.4728C124.273 79.5456 122.712 81.4094 119.483 84.2624C110.677 92.0381 114.79 105.325 114.79 106.85C116.852 104.31 118.025 103.813 121.042 103.132C123.707 102.53 127.208 103.168 128.837 103.132C133.739 103.022 137.97 100.938 139.532 97.6463C137.973 97.5366 135.41 97.3168 134.854 96.0001C144.766 95.3418 147.775 88.7598 147.775 85.2492C145.768 86.1273 143.653 86.2363 142.126 86.0227C149.556 82.507 149.764 77.6918 149.892 75.1562C150.004 72.9621 148.83 70.7832 148.314 70.7832Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M146.79 76.5701C144.222 78.5282 139.954 79.4233 136.921 80.0477C125.728 82.5308 124.894 83.587 121.744 86.2369C115.832 91.2095 116.896 100.252 117 101.209C119.464 100.042 122.17 99.8567 124.153 99.8567C126.136 99.8567 127.877 100.123 129.045 100.098C132.325 99.8567 133.437 99.2452 133.625 99.1069C131.862 97.9851 130.954 94.2791 130.491 93.2784C138.07 93.1302 141.443 91.5736 143.259 89.1647C141.48 88.9794 132.756 87.7579 131.662 87.6048C134.938 86.1072 142.573 82.8087 144.426 80.9372C145.686 79.6771 146.224 78.8803 146.79 76.5701Z"
            fill="white"
        />
    </svg>
);
